<template>
    <div class="company-article">
        <dl id="dl_en" class="hide">
        <dd>To achieve uniform wear and to maximize tread life, your tyres should be regularly rotated. Follow the vehicle manufacturer’s recommendation for the rotation pattern and interval. Unless otherwise specified by the vehicle manufacturer, ARIVO recommends to rotate the wheels axle-wise at regular intervals. For example when changing from summer tyres to winter tyres or at mileage intervals of between 5000 km and 10000km, or sooner if uneven tread wear begins to appear. If tyres start to show uneven tread wear, ask the service person to check and/or correct any vehicle wheel misalignment or other mechanical problem.</dd>
        <dd>Full-size spare tyres (not temporary spares) of the same size and construction as the ground contact tyres should be included in the tyre rotation. Always check and adjust the inflation pressure of the full-size spare when incorporating it into rotation.</dd>
        <dd>Adjust the tyre inflation pressures according to the vehicle manufacturer’s recommendation for the new wheel position (specified front and rear position tire pressures may be different).</dd>
        <dd>Rotation of your tyres may affect the Tyre Pressure Monitoring System (TPMS). Consult your vehicle owner’s manual or a qualified service professional to make the proper adjustments or recalibration of the system.</dd>
        <dd><img src="../../common/images/service/rotation_1.png" height="300"></dd>
        </dl>
        <dl id="dl_cn" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_es" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_ru" class="hide">
            <dd>test</dd>
        </dl>
    </div>
</template>
<script>
import $ from "jquery";
import Constants from "../../consts";
import VueCookies from "vue-cookies";
import consts from "../../consts";
export default {
  name: "Maintenance_Content",
  mounted: function() {
      $("#dl_en").addClass("show").removeClass("hide");
    // let lang = VueCookies.get(consts.COOKIE_LANG);
    // if (lang) {
    //   $("#dl_" + lang)
    //     .addClass("show")
    //     .removeClass("hide");
    // } else {
    //   $("#dl_en")
    //     .addClass("show")
    //     .removeClass("hide");
    // }
  }
};
</script>
<style>
.hide {
  display: none;
}
.show {
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/service/rotation_content.vue